// src/components/EnergieberegnerLayout.jsx
import Head from 'next/head';
import Image from 'next/image';
import TabbedCalculators from './TabbedCalculators';
import ActiveProjectBadge from './ActiveProjectBadge';
import uvalueIntro from '../images/system/uvalue_intro.png';
import isoverLogo from '../images/system/isoverlogo.png';
import layout from '../styles/layout.module.css';

// Fixed site-wide tab title
const SITE_TAB_TITLE = 'Digitaltbyggeri – Energieberegner';

export default function EnergiberegnerLayout({
    title = 'Energiberegner',
    description = 'Vælg mellem U-værdi, varmetabs-ramme eller årlig besparelse',
    showTabs = true,
    children,
}) {
    const displayW = 150;
    const introH = Math.round(displayW * uvalueIntro.height / uvalueIntro.width);
    const logoH = Math.round(displayW * isoverLogo.height / isoverLogo.width);

    return (
        <>
            <Head>
                <title>{SITE_TAB_TITLE}</title>
                <meta name="description" content={description} />
            </Head>

            <main className={layout.pageContainer}>
                {/* ───────── Header ───────── */}
                <header className={layout.pageHeader}>
                    {/* left block = intro icon + title/strapline */}
                    <div className={layout.headerLeft}>
                        <div className={layout.introIcon}>
                            <Image
                                src={uvalueIntro}
                                alt=""
                                width={displayW}
                                height={introH}
                                priority
                                className={layout.introImg}
                            />
                        </div>

                        <div>
                            <h1 className={layout.heading}>Energiberegner</h1>
                            <p className={layout.subheading}>
                                Brug de tre værktøjer nedenfor til at optimere dit&nbsp;byggeris energiforbrug.
                            </p>
                        </div>
                    </div>

                    {/* Isover logo – always top-right */}
                    <div className={layout.headerRight}>
                        <Image
                            src={isoverLogo}
                            alt="Isover logo"
                            width={displayW}
                            height={logoH}
                            priority
                        />
                    </div>
                </header>

                {/* ───────── Tab bar + project badge ───────── */}
                {showTabs && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', marginBottom: '1rem' }}>
                        <TabbedCalculators />
                        <ActiveProjectBadge />
                    </div>
                )}

                {/* ───────── Page content ───────── */}
                {children}
            </main>
        </>
    );
}
